const React = require('react');
const ConnectedInterestsInputField = require('containers/InterestsInputField');
const FieldContext = require('./FieldContext');

module.exports = function InterestsInputField(props) {

    const {
        field = {},
        fieldName = field.name
    } = props;

    const interestsField = FieldContext.useField(fieldName);
    const passionFieldName = field.passionFieldName || `${fieldName}Passions`;
    const passionField = FieldContext.useField(passionFieldName);
    const interests = interestsField.getValue() || [];
    const passionInterests = passionField.getValue() || [];
    const formProps = interestsField.formProps || {};
    const hasError = interestsField.hasError?.() || false;
    const errorText = interestsField.getHelperText?.() || null;

    return <ConnectedInterestsInputField
        values={interests}
        passionValues={passionInterests}
        onChange={(event, nextInterests) => {
            interestsField.setValue(nextInterests || [], undefined, event);
        }}
        onChangePassion={(nextPassionInterests) => {
            passionField.setValue(nextPassionInterests || []);
        }}
        onBlur={interestsField.onBlur}
        inputRef={interestsField.inputRef}
        showError={hasError}
        errorText={errorText}
        isSignUpPage={field.isSignUpPage ?? formProps.mode === 'signup'}
        indicatorZIndex={field.indicatorZIndex}
        {...field.interestsInputProps}
    />;
};
